import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, MapPin, Phone } from "lucide-react";
import { personalInfo } from "../constants/aboutMeData";
import "../styles/contact.css";

const Contact = () => {
	const [sending, setSending] = useState(false);
	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");
	const [name, setName] = useState("");
	const [submit, setSubmit] = useState(false);

	const botToken = import.meta.env.VITE_REACT_TELEGRAM_BOT_TOKEN;
	const chatId = import.meta.env.VITE_REACT_TELEGRAM_CHAT_ID;
	const apiUrl = `https://api.telegram.org/bot${botToken}/sendMessage`;

	const handleFormSubmit = async (e) => {
		e.preventDefault();
		try {
			setSending(true);
			const response = await axios.post(apiUrl, {
				chat_id: chatId,
				text: { name, email, message },
			});

			if (response) {
				setTimeout(() => {
					setSending(false);
				}, 500);
			}

			setTimeout(() => {
				setSubmit(false);
			}, 5000);
		} catch (error) {
			// console.log(error);
			toast.error(error.message);
			setSending(false);
		} finally {
			setName("");
			setEmail("");
			setMessage("");
			setSubmit(true);
		}
	};

	return (
		<section id="contact" className="component_wrapper">
			{/* <h2 className="sub_title title_gap">Contact</h2> */}
			<div className="contact_wrapper">
				<form
					className="contact_form_container"
					name="contact-form"
					id="contact-form"
					autoComplete="off"
					onSubmit={handleFormSubmit}
				>
					{!sending && submit && (
						<p className="success_submit">
							&#10004; &nbsp; Message has been sent!
						</p>
					)}
					
					<div className="input_container">
						<label htmlFor="name">Name</label>
						<input
							className="input_area"
							type="text"
							name="name"
							placeholder="Full name"
							// required
							id="name"
							autoComplete="off"
							value={name}
							onChange={(e) => setName(e.target.value)}
						/>
					</div>
					<div className="input_container">
						<label htmlFor="email">Email address</label>
						<input
							className="input_area"
							type="email"
							name="email"
							placeholder="your@email.com"
							// required
							id="email"
							autoComplete="off"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>
					</div>
					<div className="input_container">
						<label htmlFor="message">Message details</label>
						<textarea
							type="text"
							name="message"
							placeholder="Please provide message details"
							// required
							rows={4}
							id="message"
							autoComplete="off"
							className="input_message"
							value={message}
							onChange={(e) => setMessage(e.target.value)}
						/>
					</div>
					{!name || !email || !message ? (
						<button
							type="submit"
							disabled
							className="disabled-button"
						>
							Submit
						</button>	
						) : ( <button
						type="submit"
						className={`${sending ? "disabled-button" : "contact-button btn_primary"}`}
						>
						{sending ? "Sending..." : "Submit"}
					</button>
					)}
					
					
					<address className="contact_info">
						<div>
						<a href="tel:09553589102">
							<Phone size={16} />
							<span>{personalInfo.phoneNumber}</span>
						</a>
						</div>
						<div>
						<a href="mailto:junfeldev@gmail.com">
							<Mail size={16} />
							<span>{personalInfo.email}</span>
						</a>
						</div>
						<div>
							<MapPin size={16} />
							<span>{personalInfo.location}</span>
						</div>
					</address>
				</form>
			</div>
		</section>
	);
};

export default Contact;
